import {
  currentAppPath,
  isLibraryPagePath,
  libraryReturnPath,
  navigateApp,
  useAppPath,
} from '@/vite/navigation-store';

export { isLibraryPagePath };

export function useRouter() {
  return {
    back: () => window.history.back(),
    forward: () => window.history.forward(),
    push: (href: string) => navigateApp(href),
    refresh: () => window.location.reload(),
    replace: (href: string) => navigateApp(href, true),
  };
}

/** The current app route's pathname, without its query string. */
export function usePathname(): string {
  return new URL(useAppPath(), 'https://crowdex.invalid').pathname;
}

/** Settings covers the whole window, the shell's sidebar included (D16). */
function libraryPageCoversWindow(pathname: string): boolean {
  return pathname === '/settings';
}

/**
 * Whether a library page covers the workspace, and `leave()` to return to it — what conversation
 * controls do before acting on the hidden workspace.
 */
export function useLibraryPage() {
  const router = useRouter();
  const pathname = usePathname();
  const open = isLibraryPagePath(pathname);
  return {
    open,
    /** It covers the sidebar too (Settings): the whole shell is under it. */
    coversWindow: open && libraryPageCoversWindow(pathname),
    pathname,
    leave: () => {
      // Read now, not at render: two leaves in one gesture (an app's New … then the shell's New
      // conversation) push the way back once.
      if (!isLibraryPagePath(new URL(currentAppPath(), 'https://crowdex.invalid').pathname)) return;
      // Back to the exact path it was opened from (its conversation, or the preview, which needs
      // no sign-in); opened directly, the app's start.
      router.push(libraryReturnPath() ?? '/desktop');
    },
  };
}
